import React from 'react'
import CollapsibleCardHeader from '../../../../../components/atoms/cardHeader/collapsibleCardHeader';
import media from '../../../../../media';

const VariantDetail = ({ productbase, detail }) => {
    return (
        <div className="card">
            <CollapsibleCardHeader name="Variants" target="collapseThree" id="headingThree3" />

            <div
                id="collapseThree"
                className="collapse"
                data-parent="#vender_product_preview"
            >
                <div className="card-body">
                    <div className="table-responsive">
                        <table
                            className="table table-striped table-bordered text-center m-0"
                            border="0"
                            cellSpacing="0"
                            cellPadding="0"
                            width="100%"
                        >
                            <thead>
                                <tr>
                                    <th>Product Image</th>
                                    <th>
                                        Packaging /
                                        {productbase === "MACHINERY"
                                            ? "Model No."
                                            : "Size"}
                                    </th>
                                    {productbase === "MACHINERY" && (
                                        <th>Color</th>
                                    )}
                                    <th>MRP</th>
                                    <th>Tax Slab</th>
                                    <th>Item Dimension</th>
                                </tr>
                            </thead>
                            <tbody>
                                {detail?.variants?.length > 0 ? (
                                    detail?.variants?.map(
                                        (variant, index) => {
                                            return (
                                                <tr key={index.toString()}>
                                                    <td className="align-middle">
                                                        <img
                                                            src={
                                                                variant?.image
                                                                    ? variant?.image
                                                                    : media.Default
                                                            }
                                                            alt=""
                                                            className="border border-1 border-light-dark m-auto max-w-50px w-100"
                                                        />
                                                    </td>
                                                    <td className="align-middle font-weight-bold">
                                                        {variant?.variant}
                                                    </td>
                                                    {productbase === "MACHINERY" && <td className="align-middle font-weight-bold">
                                                        {variant?.color}
                                                    </td>}
                                                    <td className="align-middle font-weight-bold">
                                                        {variant?.price}
                                                    </td>
                                                    <td className="align-middle font-weight-bold">
                                                        {variant?.taxSlab?.en}
                                                    </td>
                                                    <td className="align-middle font-weight-bold">
                                                        {
                                                            variant?.dimension?.length
                                                                ?.quantity
                                                        }
                                                        *
                                                        {
                                                            variant?.dimension?.width
                                                                ?.quantity
                                                        }
                                                        *
                                                        {
                                                            variant?.dimension?.height
                                                                ?.quantity
                                                        }{" "}
                                                        {
                                                            variant?.dimension?.length
                                                                ?.unit
                                                        }
                                                        <span className="font-weight-bold ml-2 cursor-pointer">
                                                            {
                                                                variant?.dimension?.weight
                                                                    ?.quantity
                                                            }{" "}
                                                            {
                                                                variant?.dimension?.weight
                                                                    ?.unit
                                                            }
                                                        </span>
                                                    </td>
                                                </tr>
                                            );
                                        }
                                    )
                                ) : (
                                    <tr>
                                        <td colSpan={8} className="text-center">
                                            No Variant Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VariantDetail